(function ($) {
  // Only run if productVariants data exists (i.e. product is tagged backinstock_hide)
  if (!window.productVariants || !window.productOptionIndices) return;

  var variants = window.productVariants;
  var indices = window.productOptionIndices;

  // Convert 1-based Liquid index to variant property key
  function getOptionKey(index) {
    if (index === 1) return 'option1';
    if (index === 2) return 'option2';
    if (index === 3) return 'option3';
    return null;
  }

  var colorKey    = getOptionKey(indices.color);
  var sizeKey     = getOptionKey(indices.size);
  var materialKey = getOptionKey(indices.material);

  // Get currently selected value for a given option type
  function getSelectedValue(optionType) {
    var $wrap = $('[data-option-type="' + optionType + '"]');
    if (!$wrap.length) return null;
    if ($wrap.hasClass('option__wrap--swatches')) {
      return $wrap.find('button.active').attr('data-val') || null;
    } else {
      return $wrap.find('select').val() || null;
    }
  }

  // Filter size dropdown based on currently selected color and/or material
  function filterSizes() {
    var $sizeWrap = $('[data-option-type="size"]');
    if (!$sizeWrap.length) return;

    var selectedColor    = colorKey    ? getSelectedValue('color')    : null;
    var selectedMaterial = materialKey ? getSelectedValue('material') : null;

    var $options = $sizeWrap.find('select option');
    var firstAvailable = null;

    $options.each(function () {
      var sizeVal = $(this).val();

      // Find if any variant matches the current selections and is available
      var isAvailable = variants.some(function (v) {
        var sizeMatch     = sizeKey     ? v[sizeKey]     === sizeVal        : true;
        var colorMatch    = colorKey    && selectedColor
                           ? v[colorKey]    === selectedColor    : true;
        var materialMatch = materialKey && selectedMaterial
                           ? v[materialKey] === selectedMaterial : true;
        return sizeMatch && colorMatch && materialMatch && v.available;
      });

      if (isAvailable) {
        $(this).show().prop('disabled', false);
        if (firstAvailable === null) firstAvailable = sizeVal;
      } else {
        $(this).hide().prop('disabled', true);
      }
    });

    // Auto-select first available size
    var $select = $sizeWrap.find('select');
    if (firstAvailable !== null) {
      $select.val(firstAvailable);
    }

    // Sync to SM-RC hidden select
    var optionNum = $sizeWrap.attr('data-option');
    $('select[' + optionNum + ']').val($select.val()).change();
  }

  // Filter material dropdown based on currently selected color
  function filterMaterials() {
    if (!materialKey) return;
    var $materialWrap = $('[data-option-type="material"]');
    if (!$materialWrap.length) return;

    var selectedColor = colorKey ? getSelectedValue('color') : null;

    var $options = $materialWrap.find('select option');
    var firstAvailable = null;

    $options.each(function () {
      var materialVal = $(this).val();

      var isAvailable = variants.some(function (v) {
        var materialMatch = v[materialKey] === materialVal;
        var colorMatch    = colorKey && selectedColor
                           ? v[colorKey] === selectedColor : true;
        return materialMatch && colorMatch && v.available;
      });

      if (isAvailable) {
        $(this).show().prop('disabled', false);
        if (firstAvailable === null) firstAvailable = materialVal;
      } else {
        $(this).hide().prop('disabled', true);
      }
    });

    // Auto-select first available material
    var $select = $materialWrap.find('select');
    if (firstAvailable !== null) {
      $select.val(firstAvailable);
    }

    // Sync to SM-RC hidden select
    var optionNum = $materialWrap.attr('data-option');
    $('select[' + optionNum + ']').val($select.val()).change();
  }

  // Hide sold-out color swatches and fix default selection if needed
  function initColorSwatches() {
    var $swatchWrap = $('[data-option-type="color"]');
    if (!$swatchWrap.length) return;

    // Hide all sold-out swatches
    $swatchWrap.find('.btn--swatch--soldout').hide();

    // Check if the currently active swatch is hidden/sold-out
    var $activeBtn = $swatchWrap.find('button.active');
    if ($activeBtn.hasClass('btn--swatch--soldout') || !$activeBtn.is(':visible')) {
      // Find and activate first visible swatch
      var $firstVisible = $swatchWrap.find('.btn--swatch:visible').first();
      if ($firstVisible.length) {
        $swatchWrap.find('button').removeClass('active');
        $firstVisible.addClass('active');

        // Update color label
        $swatchWrap.find('.color-val').text($firstVisible.attr('data-val'));

        // Sync to SM-RC hidden select
        var optionNum = $swatchWrap.attr('data-option');
        $('select[' + optionNum + ']').val($firstVisible.attr('data-val')).change();
      }
    }
  }

  // Handle deep link via ?variant= param
  function handleDeepLink() {
    var params = new URLSearchParams(window.location.search);
    var variantId = params.get('variant');
    if (!variantId) return;

    // Find the variant in our data
    var linked = variants.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (!linked) return;

    // If the linked variant's color is sold out, ignore deep link color
    // and let initColorSwatches handle default selection
    if (colorKey && linked[colorKey]) {
      var colorSoldOut = !variants.some(function (v) {
        return v[colorKey] === linked[colorKey] && v.available;
      });
      if (colorSoldOut) return;

      // Activate the correct color swatch
      var $swatchWrap = $('[data-option-type="color"]');
      var $targetSwatch = $swatchWrap.find(
        '.btn--swatch[data-val="' + linked[colorKey] + '"]'
      );
      if ($targetSwatch.length && !$targetSwatch.hasClass('btn--swatch--soldout')) {
        $swatchWrap.find('button').removeClass('active');
        $targetSwatch.addClass('active');
        $swatchWrap.find('.color-val').text(linked[colorKey]);
        var optionNum = $swatchWrap.attr('data-option');
        $('select[' + optionNum + ']').val(linked[colorKey]).change();
      }
    }
  }

  // Listen for swatch clicks — re-filter sizes and materials
  $('body').on('click', '.option__wrap--swatches .btn--swatch', function () {
    // Small timeout to let the existing bundle JS update active state first
    setTimeout(function () {
      filterMaterials();
      filterSizes();
    }, 10);
  });

  // Listen for material change — re-filter sizes
  $('body').on('change', '[data-option-type="material"] select', function () {
    setTimeout(function () {
      filterSizes();
    }, 10);
  });

  // Init on page load
  $(document).ready(function () {
    handleDeepLink();
    initColorSwatches();
    filterMaterials();
    filterSizes();
  });

})(jQuery);